export default __webpack_public_path__ + "static/media/mobile_applications_s.938b2ea3.jpg";